import React, { HTMLAttributes } from "react";

export interface PaperProps extends HTMLAttributes<HTMLDivElement> {
  elevation?: number;
  square?: boolean;
  variant?: "elevation" | "outlined";
}

/**
 * Paper component wrapper for Kendo UI
 * Replaces Material UI Paper component
 */
export const Paper: React.FC<PaperProps> = ({
  children,
  elevation = 0,
  square = false,
  variant = "elevation",
  className = "",
  style,
  ...props
}) => {
  const elevationClass =
    elevation > 0 ? `k-elevation-${Math.min(elevation, 24)}` : "";
  const variantClass = variant === "outlined" ? "k-card-outlined" : "";
  const borderRadiusClass = square ? "" : "k-rounded-md";

  return (
    <div
      className={`k-card ${elevationClass} ${variantClass} ${borderRadiusClass} ${className}`.trim()}
      style={{ overflow: "visible", ...style }}
      {...props}
    >
      {children}
    </div>
  );
};

export default Paper;
